import { ContactResponseDto } from '@subflow/api-client';
import { datadogLogs } from '@datadog/browser-logs';
import { useSessionAuth } from '@subflow-frontend/hooks/useSessionAuth';
import { isSubscriberUser } from '@subflow-frontend/guards/SubscriberGuard';

export const formatSubscriberName = (firstName?: string, lastName?: string) => {
  if (firstName && lastName) {
    return firstName + ' ' + lastName;
  } else if (firstName) {
    return firstName;
  } else {
    return lastName;
  }
};

const reportedContacts = {};

// returns subscriber name, in case of broken data fallbacks to customer record
export const getSubscriberNameWithFallback = (contact: ContactResponseDto) => {
  if (contact?.subscriber) {
    return formatSubscriberName(
      contact?.subscriber?.firstName,
      contact?.subscriber?.lastName
    );
  } else if (contact) {
    if (!reportedContacts[contact.id]) {
      reportedContacts[contact.id] = true;
      console.error(
        'Sending Missing subscriber for contact error for contact: ' +
          contact.id
      );
      datadogLogs.logger.error(`Missing subscriber for contact`, {
        contactId: contact.id,
      });
    }
    return contact?.customers?.[0]?.name;
  } else {
    return 'BROKEN CUSTOMER CONTACT ADMINISTRATOR';
  }
};

export const useIsSubscriberLoggedIn = () => {
  const { isAuthenticated, session } = useSessionAuth();
  const isSubscriberLoggedIn = isSubscriberUser(session) && isAuthenticated;

  return isSubscriberLoggedIn;
};
